export enum BlockType {
    CONTROL = "Control",
    Alert = "Alert"
}